import ContactInformation from "@/components/Common/ContactInformation";
import { useState, useContext, useEffect, useCallback } from "@/common/hooks";
import { useGetStatesForEnrollmentQuery } from "@/service/APIService";
import {
  Button,
  ErrorMessage,
  Spinner,
  SuccessPopup,
} from "@/common/components";
import { PrivateContext } from "@/routes/PrivateRoute";
import {
  useSaveInsuranceCompanyContactForAdminMutation,
  useUpdateInsuranceCompanyContactForAdminMutation,
} from "@/service/AdminService";

const ContactDetails = () => {
  const {
    debounceState,
    debounceErrors,
    labels,
    location,
    cancel,
    setNavHeader,
    setPageHeader,
  } = useContext(PrivateContext);

  const [contactInfo, setContactInfo] = useState({});
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [showPopup, setShowPopup] = useState(false);

  const {
    data: states,
    isFetching: isFetching,
    error: error,
  } = useGetStatesForEnrollmentQuery();

  const [
    saveInsuranceCompanyContactApi,
    { isLoading: isFetching2, error: error2 },
  ] = useSaveInsuranceCompanyContactForAdminMutation();

  const [
    updateInsuranceCompanyContactApi,
    { isLoading: isFetching1, error: error1 },
  ] = useUpdateInsuranceCompanyContactForAdminMutation();

  const checkDisabled = useCallback(() => {
    let disable = false;

    Object.keys(errors).forEach((e) => {
      if (errors[e]) {
        disable = true;
      }
    });

    if (disable) {
      return true;
    }

    const requiredFields = [
      "firstName",
      "lastName",
      "addressLine1",
      "city",
      "zipCode",
      "phoneNumber",
      "email",
    ];

    requiredFields.forEach((e) => {
      if (!contactInfo[e]) {
        disable = true;
      }
    });

    return disable;
  }, [errors]);

  const saveOrUpdateContactDetails = () => {
    // Update
    if (location?.state?.id) {
      updateInsuranceCompanyContactApi(contactInfo)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
    // Save
    else {
      saveInsuranceCompanyContactApi(contactInfo)
        .unwrap()
        .then((res) => {
          if (!res.errors.length) {
            setShowPopup(true);
          }
        });
    }
  };

  useEffect(() => {
    setPageHeader(labels?.insuranceCompany?.contactDetails);
    setNavHeader(labels?.insuranceCompany?.navHeader);
    if (location?.state) {
      setContactInfo(location?.state);
    }
  }, []);

  return (
    <section className="container-medium py-5">
      {(isFetching || isFetching1 || isFetching2) && <Spinner />}
      <ErrorMessage error={error || error1 || error2} wrapperClassName="mb-3" />
      <ContactInformation
        contactInfo={contactInfo}
        setContactInfo={setContactInfo}
        states={states}
        errors={errors}
        setErrors={setErrors}
        touched={touched}
        setTouched={setTouched}
        debounceErrors={debounceErrors}
        debounceState={debounceState}
        labels={labels?.insuranceCompany}
        roleDropdown={true}
        rolePrimaryExists={location?.state?.primaryExists}
        confirmEmailField={false}
      />
      <div className="d-flex flex-row gap-1 justify-content-end mt-5">
        <Button
          id="cancel"
          type="secondary"
          text={labels?.insuranceCompany?.cancel}
          wrapperClassName="col-md-4 col-6"
          click={cancel}
        />
        <Button
          id="done"
          text={
            location?.state?.id
              ? labels?.insuranceCompany?.update
              : labels?.insuranceCompany?.submit
          }
          wrapperClassName="col-md-4 col-6"
          disabled={checkDisabled()}
          click={saveOrUpdateContactDetails}
        />
      </div>
      <SuccessPopup
        showModal={showPopup}
        buttonText={labels?.insuranceCompany?.continue}
        click={cancel}
        body={labels?.insuranceCompany?.requestCompleted}
      />
    </section>
  );
};

export default ContactDetails;
